export enum TypesAbsences {
    FERIAS = 0,
    ATESTADO = 1,
    FOLGA = 2,
    LICENCA = 3,
    FALTA = 4,
    OUTROS = 5
}
